import { CgProfile } from 'react-icons/cg';
import { AccountTabsType } from '../types/Tabs.type';
import { FaRegCreditCard } from 'react-icons/fa';

export const accountTabs: AccountTabsType[] = [
  { id: 1, title: 'Profile', icon: CgProfile },
  { id: 2, title: 'Payments', icon: FaRegCreditCard },
  { id: 3, title: 'Plans', icon: FaRegCreditCard },
];
